import React from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeKatex from 'rehype-katex'
import remarkMath from 'remark-math'
import 'katex/dist/katex.min.css'

import RemarkColorWord from './RemarkColorWord'


// Escape single * but not ** (for bold)
const escapeSingleAsterisk = (text) => {
  // This regex finds single * not part of **
  // It replaces * only if not immediately preceded or followed by another *
  return text.replace(/(^|[^*])\*([^*]|$)/g, (match, p1, p2) => `${p1}\\*${p2}`);
};
const MarkdownText = ({ children }) => {
  // Preprocess children to escape single * (but not **)
  const processedChildren = (typeof children === 'string') ? escapeSingleAsterisk(children) : children;

  return (
    <Markdown
      linkTarget='_blank'
      rehypePlugins={[rehypeKatex]}
      remarkPlugins={[
        RemarkColorWord,
        [remarkGfm, { singleTilde: false }],
        [remarkMath, { singleDollarTextMath: false }],
      ]}
      remarkRehypeOptions={{ handlers: { element: (h, node) => node } }}
      components={{
        a: ({ node, children, ...props }) => {
          const linkProps = props;
          
          if (props.target === '_blank') {
            linkProps.rel = 'nofollow noopener noreferrer';
          }

          return <a {...linkProps}>{children}</a>;
        },
      }}
    >
      {processedChildren}
    </Markdown>
  )

};


export { MarkdownText }
